import { useQuery } from '@tanstack/react-query';
import { WeeklySearchVolume } from '@domain/insights/models/SearchTrend';
import { container } from '@infrastructure/container';

export const useSearchVolume = (searchTerm: string) => {
  const {
    data: searchVolume,
    isLoading: isLoadingSearchTrends,
    error: searchTrendsError
  } = useQuery<WeeklySearchVolume[]>({
    queryKey: ['searchTrends', searchTerm],
    queryFn: async () => {
      const result = await container.insightsRepository.getSearchVolume(searchTerm,"NL");
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    }
  });



  return {
    searchVolume,
    isLoading: isLoadingSearchTrends,
    error: searchTrendsError
  };
};